<template>
    <div class="configuration">

        <h1>Configuration: {{ configuration.name }}</h1>

        <form v-on:submit.prevent>
            <div class="form-group row">
                <label for="staticName" class="col-sm-2 col-form-label">Name</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" id="staticName" v-model="configuration.name">
                </div>
            </div>
            <div class="form-group row">
                <label for="staticAPIKey" class="col-sm-2 col-form-label">API Key</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" id="staticAPIKey" v-model="configuration.api_key">
                </div>
            </div>
            <div class="form-group row">
                <label for="staticName" class="col-sm-2 col-form-label">Has Custom CSS</label>
                <div class="col-sm-10  text-left">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="hasCustomCSS" id="noHasCustomCSS" v-model="configuration.hasCustomCSS" :value="false">
                        <label class="form-check-label" for="noHasCustomCSS">
                            No
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="hasCustomCSS" id="yesHasCustomCSS" v-model="configuration.hasCustomCSS" :value="true">
                        <label class="form-check-label" for="yesHasCustomCSS">
                            Yes
                        </label>
                    </div>
                </div>
            </div>
            <div class="form-group row" v-if="configuration.hasCustomCSS">
                <label for="inputCss" class="col-sm-2 col-form-label">CSS</label>
                <div class="col-sm-10">
                    <textarea class="form-control" name="css" id="inputCss" rows="10" v-model="configuration.css"></textarea>
                </div>
            </div>
            <div class="form-group row">
                <label for="staticName" class="col-sm-2 col-form-label">In iFrame</label>
                <div class="col-sm-10  text-left">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="requiresIFrame" id="noIframe" v-model="configuration.requiresIFrame" :value="false">
                        <label class="form-check-label" for="noIframe">
                            No
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="requiresIFrame" id="yesIframe" v-model="configuration.requiresIFrame" :value="true">
                        <label class="form-check-label" for="yesIframe">
                            Yes
                        </label>
                    </div>
                </div>
            </div>
            <div class="form-group row" v-if="configuration.requiresIFrame">
                <label for="iFrameJsLink" class="col-sm-2 col-form-label">IFrame JS Link</label>
                <div class="col-sm-10">
                    <input class="form-control" name="iFrameJsLink" id="iFrameJsLink" rows="10" v-model="configuration.iFrameJsLink">
                </div>
            </div>
            <div class="form-group row">
                <label for="staticName" class="col-sm-2 col-form-label">Hide Dealer option</label>
                <div class="col-sm-10 text-left">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="hideDealerStage" id="NoHideDealerStage" v-model="configuration.hideDealerStage" :value="false">
                        <label class="form-check-label" for="NoHideDealerStage">
                            No
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="hideDealerStage" id="YesHideDealerStage" v-model="configuration.hideDealerStage" :value="true">
                        <label class="form-check-label" for="YesHideDealerStage">
                            Yes
                        </label>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label for="staticName" class="col-sm-2 col-form-label">GTM Integration (Vauxhall Only)</label>
                <div class="col-sm-10 text-left">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="gtmIntegrationStatus" id="GTMIntegrationDisabled" v-model="configuration.gtm.enabled" :value="false">
                    <label class="form-check-label" for="GTMIntegrationDisabled">
                      No
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="gtmIntegrationStatus" id="GTMIntegrationEnabled" v-model="configuration.gtm.enabled" :value="true">
                    <label class="form-check-label" for="GTMIntegrationEnabled">
                      Yes
                    </label>
                  </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label">Omniture (Vauxhall Only)</label>
                <div class="col-sm-10 text-left">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="omnitureStatus" id="omnitureDisabled" v-model="configuration.omniture.enabled" :value="false">
                        <label class="form-check-label" for="omnitureDisabled">
                            No
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="omnitureStatus" id="omnitureEnabled" v-model="configuration.omniture.enabled" :value="true">
                        <label class="form-check-label" for="omnitureEnabled">
                            Yes
                        </label>
                    </div>
                </div>
            </div>
            <div class="form-group row" v-if="configuration.omniture.enabled">
                <label for="omnitureUrl" class="col-sm-2 col-form-label">Omniture JS Link</label>
                <div class="col-sm-10">
                    <input class="form-control" name="omnitureUrl" id="omnitureUrl" rows="10" v-model="configuration.omniture.url">
                </div>
            </div>
            <div class="form-group row">
                <label for="preview" class="col-sm-2 col-form-label">Preview</label>
                <div class="col-sm-10 code-preview">
                    <iframe id="preview" class="iframe" frameborder="0" ref="previewIframe"></iframe>
                </div>
            </div>
            <div class="form-group row">
                <label for="iframeurl" class="col-sm-2 col-form-label">iFrame URL</label>
                <div class="col-sm-10">
                    <pre id="iframeurl" v-highlightjs="iframeurl"><code class="html"></code></pre>
                </div>
            </div>
            <div class="form-group row">
                <label for="dropcode" class="col-sm-2 col-form-label">Dropcode</label>
                <div class="col-sm-10">
                    <pre id="dropcode" v-highlightjs="sourcecode"><code class="html"></code></pre>
                </div>
            </div>
            <div class="form-group row">
                <label for="inputCss" class="col-sm-2 col-form-label"></label>
                <div class="col-sm-10 text-left">
                    <button type="submit" class="btn btn-primary" @click="saveNewConfiguration(configuration)">Save</button>
                    <button type="submit" class="btn btn-primary" @click="returnToDashboard">Back</button>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    /* eslint-disable */
    import { mapGetters, mapActions } from 'vuex';
    import router from '../router';

    export default {
        name: 'Configuration',
        cssReset: '<style>html { height: 100% } body { height: 100%; margin: 0 }</style>',
        computed: {
            ...mapGetters(['user', 'isAuthenticated', 'configuration']),
            sourcecode() {
                const frontendEndpoint = process.env.FRONTEND_ENDPOINT;
                const frontendEndJsFile = process.env.FRONTEND_JS_FILE;
                const markup = `<service-plan-widget token="${this.configuration.configuration_hash}"><\/service-plan-widget>`;
                const script = `<script type="text/javascript" src="${frontendEndpoint}static/js/${frontendEndJsFile}.js"><\/script>`;
                return `${markup}
${script}`;
            },
            iframeurl() {
                const frontendEndpointURL = process.env.FRONTEND_ENDPOINT + '?' + this.configuration.configuration_hash;
                return `${frontendEndpointURL}`;
            },
        },
        methods: {
            ...mapActions(['saveConfiguration']),
            returnToDashboard(){
                router.push('/dashboard');
            },
            injectToIframe() {
                this.$refs.previewIframe.src = process.env.FRONTEND_ENDPOINT + '?' + this.configuration.configuration_hash;
            },
            saveNewConfiguration(configuration) {
                this.saveConfiguration(configuration)
                    .then(() => {
                        this.injectToIframe();
                    });
            },
        },
        created() {
            // eslint-disable-next-line
            this.$store.dispatch('getConfiguration', this.$route.params.configurationHash )
                .then(() => {
                    this.injectToIframe();
                })
                .catch(() => {
                    this.injectToIframe();
                });
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    @import '../assets/css/vs2015.css';

    .hljs {
        padding: 1em;
        border-radius: .5em;
    }

    .code-preview {
        max-width: 1170px;

        .iframe {
            min-height: 500px;
            width: 100%;
            border: 1px solid #ced4da;
            border-radius: .25rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Configuration.vue